var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUzbekistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3610_27217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0.000701904H0V32H32V0.000701904Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3610_27217)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22H32V33H0V22Z",
    fill: "#00B731"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V10H0V0Z",
    fill: "#03BCDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.8264H32V19.8125H0V11.8264ZM7.61905 9.0934C7.38133 9.18125 7.12381 9.22917 6.85714 9.22917C5.59543 9.22917 4.57143 8.15583 4.57143 6.83333C4.57143 5.51083 5.59543 4.4375 6.85714 4.4375C7.12381 4.4375 7.38133 4.48542 7.61905 4.57326C6.73067 4.90229 6.09524 5.79035 6.09524 6.83333C6.09524 7.87632 6.73067 8.76597 7.61905 9.0934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.66667H10.8V7.33333H9V5.66667ZM10.8 4H12.6V5.66667H10.8V4ZM12.6 5.66667H14.4V7.33333H12.6V5.66667ZM14.4 4H16.2V5.66667H14.4V4ZM16.2 5.66667H18V7.33333H16.2V5.66667ZM14.4 7.33333H16.2V9H14.4V7.33333ZM10.8 7.33333H12.6V9H10.8V7.33333Z",
    fill: "#1A47B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3610_27217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3610_27217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/Uzbekistan.588c5955da0230b1fd198722c1612a24.svg";
export { ForwardRef as ReactComponent };